import e from "./ExternalDocs.vue.script.js";
//#region src/shared/ExternalDocs.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=ExternalDocs.vue.js.map